import { createReducer } from 'redux-act';
import ActionTypes from './ActionTypes';
import Node from './Node';
import sharedObject from 'kts-platform-frame/sharedObject';
import Cookies from 'js-cookie';

let defaultState;
// 如果 cookie 存在才会去获取 localStorage 的数据
if (document.cookie) {
    defaultState = JSON.parse(window.localStorage.getItem('$$/user')) || new Node();
} else {
    defaultState = new Node();
}

const reducer = createReducer(
    {
        [ActionTypes.fnSetUserInfo as any]: (state, payload) => {
            const userInfo = {
                ...state,
                ...payload
            };
            userInfo.cToken ? Cookies.set('cToken', userInfo.cToken) : Cookies.remove('cToken');
            sharedObject.set('$$/user', JSON.stringify(userInfo));
            return userInfo;
        },
    },
    defaultState
);

export default reducer;


// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/redux/reducers/user/reducer.ts